import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/LanguageContext";
import { EMAIL } from "@/i18n";
import { ChapterLabel, MaskedLine, Reveal } from "@/components/Reveal";

const Services = () => {
  const { t } = useLanguage();
  const s = t.services;

  return (
    <section id="servizi" className="border-b border-noom-line bg-noom-paper" data-testid="section-services">
      <div className="mx-auto max-w-[1600px] px-6 py-24 lg:px-16 lg:py-36">
        <ChapterLabel testId="services-label">{s.label}</ChapterLabel>
        <h2 className="mt-6 font-display text-4xl font-semibold tracking-[-0.02em] text-noom-ink sm:text-5xl">
          <MaskedLine inView>{s.heading}</MaskedLine>
        </h2>

        <div className="mt-14 grid gap-6 lg:grid-cols-3" data-testid="grid-studio-services">
          {s.items.map((card, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <article
                data-testid={`service-card-${i + 1}`}
                className="group flex h-full flex-col border border-noom-line bg-white p-8 transition-all duration-500 ease-noom hover:-translate-y-1.5 hover:border-noom-ink lg:p-10"
              >
                <span className="inline-flex w-fit rounded-full bg-noom-lilacLight px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-noom-lilacDeep">
                  {card.tag}
                </span>
                <h3 className="mt-6 font-display text-2xl font-semibold tracking-tight text-noom-ink">{card.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-noom-muted sm:text-base">{card.desc}</p>
                <ul className="mt-8 flex-1 space-y-3.5">
                  {card.items.map((item, j) => (
                    <li key={j} className="flex items-center gap-3 text-sm text-noom-ink">
                      <span className="h-1.5 w-1.5 shrink-0 bg-noom-lilac transition-transform duration-300 group-hover:rotate-45" />
                      {item}
                    </li>
                  ))}
                </ul>
                <a
                  data-testid={`service-cta-${i + 1}`}
                  href={`mailto:${EMAIL}?subject=${encodeURIComponent(card.title)}`}
                  className="mt-10 inline-flex items-center gap-2 border-t border-noom-line pt-6 font-mono text-[11px] uppercase tracking-[0.22em] text-noom-ink transition-colors duration-300 hover:text-noom-lilacDeep"
                >
                  {s.cta}
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
